import { CategorySuggestion, ProductSuggestion, ServiceSuggestion } from 'types/suggestions';

export function getServicesListDivider(
  slicedProducts: ProductSuggestion[],
  slicedCategories: CategorySuggestion[],
  slicedServices: ServiceSuggestion[],
) {
  return (slicedProducts.length > 0 || slicedCategories.length > 0) && slicedServices.length > 0;
}
